<template lang="pug">
  .section-layout
    .nav-back-btn(@click="goBack")

    .c-tab
      .c-tab-item(:class="{'c-tab-active' : tab_active === 1, 'c-tab-over' : tab_over === 3}",
        @click="goTab(1)") 1. 选择活动模板
      .c-tab-item(:class="{'c-tab-active' : tab_active === 2, 'c-tab-over' : tab_over === 3}",
        @click="goTab(2)") 2. 活动信息配置
      .c-tab-item(:class="{'c-tab-active' : tab_active === 3, 'c-tab-over' : tab_over === 3}",
        @click="goTab(3)") 3. 活动组件配置

    step-one(v-if="tab_active === 1", @goback="goBack", @nextstep="next")
    step-two(v-show="tab_active === 2", @nextstep="next", :template_id="template_id", :activity_id="activity_id", :is_edit="is_edit", :is_show="tab_active === 2 ? true : false", @prevstep="prev", :is_save_data="is_save_data")
    step-three(v-if="tab_active === 3", :params="info", :is_edit="is_edit", @prevstep="prev")
</template>

<script>
import Api from '@/mixins/modules/Content'
import StepOne from '@/components/content/modal/ContentTemplateOne'
import StepTwo from '@/components/content/modal/ContentTemplateTwo'
import StepThree from '@/components/content/modal/ContentTemplateThree'
export default {
  name: 'contentTemplateCreate',
  mixins: [Api],
  components: {
    StepOne,
    StepTwo,
    StepThree,
  },
  data () {
    return {
      tab_active: 1,  // 页面tab初始值
      tab_over: 1,  // 完成到第几步
      is_save_data: false, // 是否保留数据之前数据,不重新请求接口（用于第3步向第2步返回）
      template_id: '', // 模板id
      activity_id: '', // 活动id
      is_edit: false, // 是否为编辑（直接跳转第二步）
      info: {}, // 活动数据
    }
  },
  methods: {
    // 返回列表页
    goBack () {
      this.$router.push({
        name: 'contentList',
      })
    },
    // 不等于 3 表示在新增, 新增不支持跳转
    goTab (step) {
      if (this.tab_over !== 3) {
        return false
      }
    },

    // 下一步
    // step: 步骤数， templateInfo: 模板id， info: 活动信息
    next (step, templateId, info) {
      if (step === 2) {
        this.template_id = templateId
      } else if (step === 3) {
        this.info = info
      }
      this.tab_active = step
    },

    // 上一步
    // step: 步骤数，isSaveData: 是否保留数据之前数据,不重新请求接口（用于第3步向第2步返回）
    prev (step, isSaveData) {
      if (isSaveData) this.is_save_data = true
      else this.is_save_data = false
      this.tab_active = step
    },
  },
  mounted () {
    // 如果是编辑，直接跳第二步
    if (this.$route.query.isEdit) {
      this.is_edit = true
      this.activity_id = this.$route.query.activity_id
      this.tab_active = 2
    } else {
      this.is_edit = false
      this.tab_active = 1
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.content-wrapper
  height 100%
.nav-back-btn
  position absolute
  top 14px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.c-tab
  display flex
  height 60px
  background #fff
  border-bottom 1px solid #f1f1f1
  .c-tab-item
    display flex
    align-items center
    justify-content center
    width 30%
    height 100%
    font-size 14px
  .c-tab-active
    color #2fabdd
    font-size 16px
  .c-tab-over
    color #2fabdd
    cursor pointer
</style>


// WEBPACK FOOTER //
// src/components/content/ContentTemplateCreate.vue